import React from 'react';
import usePageMeta from '../../hooks/usePageMeta';
import Hero from './Hero';
import Logos from './Logos';
import Features from './Features';
import Showcase from './Showcase';
import ArticlesTeaser from './ArticlesTeaser';
import HowItWorks from './HowItWorks';
import Comparison from './Comparison';
import Calculator from './Calculator';
import Tariff from './Tariff';
import FAQ from './FAQ';
import FinalCTA from './FinalCTA';

// Главная страница startklass.ru. Каждый блок — отдельный компонент.
//
// Порядок: верх → знакомство и доказательства → калькулятор окупаемости →
// тариф → FAQ → финальный CTA. Calculator стоит ПЕРЕД тарифом, чтобы лид
// сначала увидел «сколько заработаю», и только потом цену подписки.
// Comparison идёт после HowItWorks как итог раздела «зачем это нужно».
export default function Landing() {
    usePageMeta({
        title: 'СтартКласс — IT-программа для детского центра под ключ',
        description: 'Готовая платформа: программирование, робототехника и админ-панель центра. 200 учеников и 5 преподавателей за 150 000 ₽ в год.',
        canonical: 'https://startklass.ru/',
    });
    return (
        <main>
            <Hero/>
            <Logos/>
            <Features/>
            <Showcase/>
            <ArticlesTeaser/>
            <HowItWorks/>
            <Comparison/>
            <Calculator/>
            <Tariff/>
            <FAQ/>
            <FinalCTA/>
        </main>
    );
}
